export const fromZerotoNaN = (
  props: (number | null | undefined)[],
): number[] => {
  return props.map((item) => {
    return item === null || item === undefined ? NaN : item;
  });
};

export const getPercentages = (arr: number[], value: number): string => {
  const totalSum = arr.reduce((sum, value) => sum + value, 0);
  const percentValue = (value / totalSum) * 100;
  if (Number.isNaN(percentValue)) {
    return `0%`;
  } else {
    return `${percentValue.toFixed(2)}%`;
  }
};
